export const validateField = ({ validations, formInput }) => {
  if (validations)
    for (let i = 0; i < validations.length; i++) {
      formInput.error = "";
      if (validations[i].type === "REQUIRED" && !formInput.value) {
        formInput.error = validations[i].message;
        return formInput;
      }
      if (
        validations[i].type === "REGEX" &&
        !validations[i].expression.test(formInput.value)
      ) {
        formInput.error = validations[i].message;
        return formInput;
      }
    }
  return formInput;
};

export const validateOnSubmit = (copyFormInputs) => {
  let errors = [];
  if (copyFormInputs) {
    for (let i = 0; i < copyFormInputs.length; i++) {
      const validations = copyFormInputs[i].validations;

      copyFormInputs[i] = validateField({
        validations,
        formInput: copyFormInputs[i],
      });
    }

    console.log({ copyFormInputs });

    errors = copyFormInputs.filter(
      (formInput) => formInput.error && formInput.error != ""
    );
  }

  return errors;
};

export const getFormValues = (inputs) => {
  let values = {};
  for (let i = 0; i < inputs.length; i++) {
    values[inputs[i].name] = inputs[i].value;
  }

  return values;
};
